import { render, staticRenderFns } from "./marketEnter.vue?vue&type=template&id=2813cd6a&scoped=true"
import script from "./marketEnter.vue?vue&type=script&lang=js"
export * from "./marketEnter.vue?vue&type=script&lang=js"
import style0 from "./marketEnter.vue?vue&type=style&index=0&id=2813cd6a&prod&scoped=true&lang=css"
import style1 from "./marketEnter.vue?vue&type=style&index=1&id=2813cd6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813cd6a",
  null
  
)

export default component.exports